function trackPageView() {
	if (typeof ga !== 'function') {
		return;
	}
	ga('send', 'pageview', location.pathname);
}
function trackEvent(eventCategory, eventAction, eventLabel = {}, eventValue = 0) {
	if (typeof ga !== 'function') {
		return;
	}
	ga('send', {
		hitType: 'event',
		eventCategory,
		eventAction,
		eventLabel,
		eventValue
	});
}

export { trackPageView, trackEvent };